module.exports = __webpack_public_path__ + "static/turquia-025.thumb-d41e163642ed08a16b47b0e02a8c94be.jpg";